module.exports = __webpack_public_path__ + "assets/img/video-play-new.3a612440.png";